var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"marketing-hint",style:({ backgroundColor: _vm.marketingHint.color })},[(_vm.iconSrc)?_c('img',{staticClass:"marketing-hint__icon",attrs:{"src":_vm.iconSrc,"alt":_vm.iconAlt}}):_c('IconSvg',{attrs:{"filepath":"star.svg"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.marketingHint.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }